"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _tpmProductIntl = require("@tencent/tpm-product-intl");
var _reportUtil = require("../../utils/reportUtil");
var _componentUtils = require("../../common/componentUtils");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 *
 * @description TmpCompliance
 * @author garythtu
 * @created 2025-12-10 07:14:13
 */
/**
 * 格式化组件数据
 * @param properties 组件属性
 * @param options 选项
 * @returns 格式化后的数据
 */
const formatTmpComplianceData = (properties, _options = {}) => {
  const _ref = properties || {},
    _ref$porintId = _ref.porintId,
    porintId = _ref$porintId === void 0 ? '' : _ref$porintId,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'default' : _ref$bg,
    _ref$list = _ref.list,
    list = _ref$list === void 0 ? [] : _ref$list,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? 3 : _ref$columns,
    _ref$openText = _ref.openText,
    openText = _ref$openText === void 0 ? '' : _ref$openText,
    _ref$packText = _ref.packText,
    packText = _ref$packText === void 0 ? '' : _ref$packText;
  const handledList = list.map((activityItem, listIndex) => {
    const _ref2 = activityItem || {},
      _ref2$itemList = _ref2.itemList,
      itemList = _ref2$itemList === void 0 ? [] : _ref2$itemList,
      _ref2$desc = _ref2.desc,
      desc = _ref2$desc === void 0 ? '' : _ref2$desc,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? '' : _ref2$title;
    const handledItemList = itemList.map((activityItem, itemIndex) => {
      const _ref3 = activityItem || {},
        _ref3$icon = _ref3.icon,
        icon = _ref3$icon === void 0 ? '' : _ref3$icon,
        _ref3$title = _ref3.title,
        title = _ref3$title === void 0 ? '' : _ref3$title,
        _ref3$desc = _ref3.desc,
        desc = _ref3$desc === void 0 ? '' : _ref3$desc,
        linkText = _ref3.linkText,
        _ref3$linkHref = _ref3.linkHref,
        linkHref = _ref3$linkHref === void 0 ? '' : _ref3$linkHref;
      const linkExtendProps = {
        'report-event': 'click_Compliance_link',
        'report-ext1': itemIndex,
        'report-ext2': linkHref,
        target: '_blank'
      };
      let linkElement = null;
      if (linkText) {
        linkElement = /*#__PURE__*/React.createElement(_tpmProductIntl.Link, _objectSpread({
          key: `link-${listIndex}-${itemIndex}`,
          href: linkHref,
          icon: true
        }, linkExtendProps), linkText);
      }
      return {
        title,
        desc,
        icon: (0, _componentUtils.doComponentsUploadEvent)(icon).url,
        link: linkElement
      };
    });
    return {
      itemList: handledItemList,
      desc,
      title
    };
  });
  return {
    porintId,
    bg,
    columns: Number(columns),
    openText,
    packText,
    list: handledList
  };
};
function _default({
  componentKey,
  data,
  domains: domainInfos
}) {
  // 必须无条件调用 Hook，避免条件返回导致 Hook 数量不一致
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    // 先格式化数据
    const _formatTmpComplianceD = formatTmpComplianceData(data, {
        domains
      }),
      porintId = _formatTmpComplianceD.porintId,
      bg = _formatTmpComplianceD.bg,
      list = _formatTmpComplianceD.list,
      columns = _formatTmpComplianceD.columns,
      openText = _formatTmpComplianceD.openText,
      packText = _formatTmpComplianceD.packText;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId,
      className: `gems-materials-qci____newUI-TmpCompliance`
    }, (0, _reportUtil.reportShow)(['show_newUI_TmpCompliance', componentKey, porintId || ''])), /*#__PURE__*/React.createElement(_tpmProductIntl.Section, {
      bg: bg
    }, /*#__PURE__*/React.createElement(_tpmProductIntl.Compliance, {
      list: list,
      columns: columns,
      openText: openText,
      packText: packText
    })));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}